import { createAutoformatPlugin, AutoformatPlugin } from '@udecode/plate';
import { CONFIG } from '../../config/config';
import { createMyPlugins, MyEditor, MyValue } from '../../config/typescript';

export const autoformatPlugin = createMyPlugins([createAutoformatPlugin(CONFIG.autoformat)]);
